import React from 'react';

const TagDisplayList = ({ tags, maxDisplay = 3 }) => {
    if (!tags || tags.length === 0) return null;

    const displayTags = tags.slice(0, maxDisplay);
    const extraTags = tags.length - maxDisplay;

    return (
        <div className="flex flex-wrap gap-1 mt-1">
            {displayTags.map(tag => (
                <span 
                    key={tag.id}
                    className="text-[10px] px-1.5 py-0.5 rounded-sm font-medium text-white shadow-sm whitespace-nowrap"
                    style={{ backgroundColor: tag.color }}
                    title={tag.name}
                >
                    {tag.name}
                </span>
            ))}
            {extraTags > 0 && (
                <span className="text-[10px] px-1.5 py-0.5 rounded-sm bg-gray-600 text-gray-200 shadow-sm whitespace-nowrap">
                    +{extraTags}
                </span>
            )}
        </div>
    );
};

export default TagDisplayList;
